<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="summaryList" v-loading="loading" row-key="TeacherMasterId"
        class="custom-tbl" style="width: 100%" height="100%">
        <el-table-column prop="TeacherName" label="教师" width=""></el-table-column>
        <el-table-column prop="ScheduledCount" label="应到节次" width=""></el-table-column>
        <el-table-column prop="CheckedInCount" label="已签到" width=""></el-table-column>
        <el-table-column prop="MissedCount" label="未签到" width=""></el-table-column>
        <el-table-column label="签到率" width="">
          <template slot-scope="scope">{{ scope.row.CheckInRate != null ? scope.row.CheckInRate + '%' : '0%' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetails(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handlePageChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <el-dialog title="教师课程签到明细" :visible.sync="detailDialogVisible" width="70%"
        class="teacher-checkin-detail-dialog">
        <el-table :data="detailList" v-loading="detailLoading" class="teacher-checkin-detail-table"
          style="width:100%">
          <el-table-column label="日期" width="120">
            <template slot-scope="scope">{{ formatDateOnly(scope.row.AttendDate) }}</template>
          </el-table-column>
          <el-table-column prop="DepartmentName" label="班级" width=""></el-table-column>
          <el-table-column label="节次" width="80">
            <template slot-scope="scope">第{{ scope.row.ClassNo }}节</template>
          </el-table-column>
          <el-table-column prop="CourseName" label="课程" width=""></el-table-column>
          <el-table-column prop="TimeRange" label="时段" width="140"></el-table-column>
          <el-table-column label="签到状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.CheckedIn" style="color:#67C23A">已签到</span>
              <span v-else style="color:#F56C6C">未签到</span>
            </template>
          </el-table-column>
          <el-table-column label="签到时间" width="160">
            <template slot-scope="scope">{{ scope.row.CheckInTime ? formatDate(scope.row.CheckInTime) : '-' }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-container" style="margin-top: 12px; overflow: hidden;">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleDetailPageChange"
            :page-size="detailPageSize" :total="detailTotal" style="float: right">
          </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "@/components/DepartmentPane";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { getTeacherCourseCheckInSummary, getTeacherCourseCheckInDetails, getTeacherCourseCheckInSummaryExport } from '../../api/modules/schedule-course';

export default {
  components: { DepartmentPane, Toolbar },
  data() {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 6);
    const fmt = (d) => {
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${y}-${m}-${day}`;
    };
    return {
      buttonList: [],
      searchList: [
        { label: "开始日期", key: "startDate", type: "date", initValue: fmt(start) },
        { label: "结束日期", key: "endDate", type: "date", initValue: fmt(end) },
        { label: "教师姓名", key: "keyword", type: "input" },
      ],
      filters: { startDate: fmt(start), endDate: fmt(end), keyword: "" },
      departmentId: 0,
      summaryList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      detailDialogVisible: false,
      detailList: [],
      detailLoading: false,
      detailPage: 1,
      detailPageSize: 10,
      detailTotal: 0,
      currentTeacherMasterId: 0,
      listRequestId: 0,
    };
  },
  methods: {
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    treeNodeClick(data) {
      const id = data && data.value ? data.value : 0;
      if (id === this.departmentId && this.summaryList.length) return;
      this.departmentId = id;
      if (this.departmentId == 0) {
        this.$message({ message: "请选择具体的学校或下级节点", type: "error" });
        this.summaryList = [];
        this.total = 0;
        return;
      }
      this.page = 1;
      this.loadList();
    },
    handleQuery() {
      this.page = 1;
      this.loadList();
    },
    async exportExcel() {
      if (!this.departmentId) {
        this.$message({ message: "请先选择学校或下级节点", type: "warning" });
        return;
      }
      try {
        const response = await getTeacherCourseCheckInSummaryExport({
          departmentId: this.departmentId,
          ...this.filters,
        });
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "教师课程签到统计.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("导出失败:", error);
        this.$message({ message: "导出失败", type: "error" });
      }
    },
    loadList() {
      if (!this.departmentId) return;
      const requestId = ++this.listRequestId;
      this.loading = true;
      const params = {
        departmentId: this.departmentId,
        page: this.page,
        pageSize: this.pageSize,
        ...this.filters,
      };
      getTeacherCourseCheckInSummary(params)
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          const body = res && res.data;
          const r = body && body.response;
          if (body && body.success === false) {
            this.$message({ message: body.msg || "查询失败", type: "error" });
            this.summaryList = [];
            this.total = 0;
            return;
          }
          this.summaryList = (r && r.data) ? r.data : [];
          this.total = (r && r.dataCount) ? r.dataCount : 0;
        })
        .catch(() => {
          if (requestId !== this.listRequestId) return;
          this.summaryList = [];
          this.total = 0;
        })
        .finally(() => {
          if (requestId === this.listRequestId) this.loading = false;
        });
    },
    handlePageChange(p) {
      if (p === this.page) return;
      this.page = p;
      this.loadList();
    },
    showDetails(row) {
      this.currentTeacherMasterId = row.TeacherMasterId;
      this.detailPage = 1;
      this.detailDialogVisible = true;
      this.loadDetailList();
    },
    loadDetailList() {
      if (!this.currentTeacherMasterId || !this.departmentId) return;
      this.detailLoading = true;
      getTeacherCourseCheckInDetails({
        teacherMasterId: this.currentTeacherMasterId,
        departmentId: this.departmentId,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        page: this.detailPage,
        pageSize: this.detailPageSize,
      })
        .then((res) => {
          const r = res && res.data && res.data.response;
          this.detailList = (r && Array.isArray(r.data)) ? r.data : [];
          this.detailTotal = (r && r.dataCount) ? r.dataCount : 0;
        })
        .catch(() => {
          this.detailList = [];
          this.detailTotal = 0;
        })
        .finally(() => { this.detailLoading = false; });
    },
    handleDetailPageChange(p) {
      if (p === this.detailPage) return;
      this.detailPage = p;
      this.loadDetailList();
    },
    formatDateOnly(v) {
      if (!v) return "";
      if (typeof v === "string") return v.split(" ")[0];
      try {
        const d = new Date(v);
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
      } catch (e) { return v; }
    },
    formatDate(v) {
      if (!v) return "";
      try { return new Date(v).toLocaleString(); } catch (e) { return v; }
    },
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.teacher-checkin-detail-dialog ::v-deep .el-dialog__body {
  min-height: 280px;
  box-sizing: border-box;
}

.teacher-checkin-detail-table ::v-deep .el-table__body-wrapper {
  min-height: 190px;
}

.teacher-checkin-detail-table ::v-deep .el-table__row > td {
  height: 48px;
}
</style>
